export default __webpack_public_path__ + "static/media/truck-gray.b3db4ccf.svg";